/* Product page: model chips, "Fits" line, "Complete your set" refresh.
   Model chips keep the theme's original dropdown behaviour: choosing a model saves it and tells the recommendation blocks to refresh,
   so the recommendations further down (matched by gender + saved model) always agree with the selection. */
(function () {
  'use strict';
  var KEY = 'user_selected_device_model';
  var norm = function (t) { return String(t == null ? '' : t).replace(/[\s ]+/g, ' ').split(/[\/\-,]/)[0].trim(); };
  var chips = function () { return Array.prototype.slice.call(document.querySelectorAll('.ipc-model-opt input[type="radio"]')); };
  var store = {
    get: function () { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
    set: function (v) { try { localStorage.setItem(KEY, v); } catch (e) { /* storage blocked */ } }
  };

  /* 1. choosing a model: save it, reload only if it changed (same rule as the old dropdown) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || t.type !== 'radio' || !t.closest('.ipc-model-opt')) return;
    var c = norm(t.value);
    if (!c) return;
    var cur = store.get();
    if (!cur || cur.trim().toLowerCase() !== c.toLowerCase()) { store.set(c); document.dispatchEvent(new CustomEvent('ipc:model-change', { detail: { model: c } })); }
  }, true);

  /* 2. on load: select the saved model's chip (the old dropdown did this too) */
  function applySaved() {
    var radios = chips();
    if (!radios.length) return;
    /* a product with a single model saves it (the old dropdown did the same) */
    if (radios.length === 1) { store.set(norm(radios[0].value)); return; }
    var saved = store.get();
    if (!saved) {
      var on = radios.filter(function (r) { return r.checked; })[0];
      if (on) store.set(norm(on.value));
      return;
    }
    var want = saved.trim().toLowerCase();
    var match = radios.filter(function (r) {
      return norm(r.value).toLowerCase() === want || r.value.trim().toLowerCase() === want;
    })[0];
    if (match) {
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* 3. "Fits iPhone X" line follows the selected model (chip or dropdown) */
  function currentModel() {
    var on = chips().filter(function (r) { return r.checked; })[0];
    if (on) return on.value;
    var sel = document.querySelector('select.ipc-model-sel');
    if (sel) { var o = sel.options[sel.selectedIndex]; return (o && o.text) || sel.value; }
    return null;
  }
  function syncFit() {
    var m = currentModel();
    if (!m) return;
    Array.prototype.forEach.call(document.querySelectorAll('ipc-fit'), function (el) {
      var name = el.querySelector('[data-ipc-fit-name]');
      if (name) name.textContent = String(m).trim();
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && (t.closest('.ipc-model-opt') || (t.matches && t.matches('select.ipc-model-sel')))) syncFit();
  });

  /* Select the saved model only once the theme's variant code is live, so price, photos, header and URL follow it. */
  var applied = false;
  function applyOnce() {
    if (applied) return;
    applied = true;
    applySaved(true);
    syncFit();
    scrollChips();
    setTimeout(scrollChips, 250);
    setTimeout(scrollChips, 900);
  }
  function scrollChips() {
    Array.prototype.forEach.call(document.querySelectorAll('.ipc-chip-row'), function (row) {
      var on = row.querySelector('input:checked');
      var lbl = on && on.nextElementSibling;
      if (lbl) {
        var dx = lbl.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - lbl.offsetWidth) / 2;
        row.scrollLeft = Math.max(0, row.scrollLeft + dx);
      }
      var scrollable = row.scrollWidth > row.clientWidth + 4;
      row.classList.toggle('is-scroll', scrollable);
      row.classList.toggle('at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
      if (!row._ipcBound) {
        row._ipcBound = true;
        row.addEventListener('scroll', function () { row.classList.toggle('at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4); }, { passive: true });
      }
    });
  }
  function boot() {
    if (!chips().length) { syncFit(); return; }
    var ready = window.customElements && customElements.whenDefined ? customElements.whenDefined('variant-selects') : Promise.resolve();
    ready.then(function () {
      /* the theme's photo gallery must be live too, or its variant handler stops halfway */
      var tries = 0;
      (function wait() {
        var galleries = document.querySelectorAll('[id^="MediaGallery-"]');
        var ok = Array.prototype.every.call(galleries, function (g) { return typeof g.setActiveMedia === 'function'; });
        if (ok || tries++ > 60) applyOnce(); else setTimeout(wait, 100);
      })();
    });
    syncFit();
    scrollChips();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(boot, 300);
  window.addEventListener('resize', scrollChips);
  window.addEventListener('load', scrollChips);

  /* 4. "Complete your set" re-renders for the selected variant (also fires after step 2 re-selects the saved model) */
  if (!customElements.get('ipc-set')) {
    customElements.define('ipc-set', class IpcSet extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        var self = this;
        this._unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (v && v.id) self.refresh(v.id);
        });
      }
      disconnectedCallback() { if (this._unsub) this._unsub(); }
      refresh(id) {
        var self = this;
        this._last = id;
        fetch(this.dataset.url + '?variant=' + id + '&section_id=' + this.dataset.sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (self._last !== id) return;
            var src = new DOMParser().parseFromString(html, 'text/html').querySelector('ipc-set');
            if (src) {
              var h = self.offsetHeight; if (h > (self._h || 0)) self._h = h; // hold the height so the swap cannot move what is below
              self.style.minHeight = self._h + 'px';
              self.innerHTML = src.innerHTML;
            }
          })
          .catch(function () { /* keep what is shown */ });
      }
    });
  }
})();
